export function LogoMark({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true" data-testid="logo-mark">
      <polygon
        points="24,3 38.6,9.4 45,24 38.6,38.6 24,45 9.4,38.6 3,24 9.4,9.4"
        stroke="url(#mc-gold-grad)"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M15 33.5V15.5L24 26.5L33 15.5V33.5"
        stroke="#F3E5AB"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="24" cy="33.5" r="1.4" fill="#D4AF37" />
      <defs>
        <linearGradient id="mc-gold-grad" x1="3" y1="3" x2="45" y2="45">
          <stop stopColor="#F3E5AB" />
          <stop offset="0.5" stopColor="#D4AF37" />
          <stop offset="1" stopColor="#AA7C11" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function Logo({ compact = false }) {
  return (
    <span className="flex items-center gap-3" data-testid="brand-logo">
      <LogoMark size={compact ? 34 : 40} />
      <span className="flex flex-col leading-none">
        <span className="font-serif text-lg sm:text-xl tracking-[0.18em] text-slate-100">
          MEDIOLANUM
        </span>
        <span className="font-mono text-[10px] tracking-[0.42em] text-gold mt-1">
          CONSULTING
        </span>
      </span>
    </span>
  );
}
